import { EMPTY_FIELD } from 'constants/emptyField';

import { Avatar } from 'shared/mui/Avatars';
import { Chip } from 'shared/mui/Chips';
import { FunctionField } from 'shared/react-admin/Fields';
import { User } from 'types/embedded/user';

export const UserRoleChipField: React.FC = () => {
  return (
    <FunctionField
      render={({ roleEntities }: User) => {
        if (!roleEntities) {
          return EMPTY_FIELD;
        }
        return (
          <Chip
            avatar={<Avatar src={roleEntities[0]?.roleCategories.description} />}
            label={roleEntities[0]?.name}
          />
        );
      }}
    />
  );
};
